// import React from "react";
// import { makeStyles } from "@mui/styles";
// import { Backdrop, Typography } from "@mui/material";

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     top: 0,
//     left: 0,
//     width: "100vw",
//     height: "100vh",
//     display: "flex",
//     position: "fixed",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: theme.zIndex.drawer + 1,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//   },
//   card: {
//     width: "50%", // Adjusts width for smaller devices
//     maxWidth: "400px", // Sets a maximum width
//     height: "auto",
//     display: "flex",
//     textAlign: "center",
//     borderRadius: "8px",
//     alignItems: "center",
//     flexDirection: "column",
//     backgroundColor: "#fff",
//     padding: theme.spacing(4),
//     justifyContent: "center",
//     // boxShadow: theme.shadows[5],
//     [theme.breakpoints.down("sm")]: {
//       padding: theme.spacing(3), // Adjusts padding for tablets
//     },
//     [theme.breakpoints.down("xs")]: {
//       padding: theme.spacing(2), // Adjusts padding for mobile devices
//     },
//   },
//   spinner: {
//     width: "70%", // Spinner scales with the card width
//     marginBottom: theme.spacing(2),
//     [theme.breakpoints.down("xs")]: {
//       width: "60%", // Smaller spinner for extra small devices
//     },
//   },
//   text: {
//     fontSize: 18,
//     fontWeight: "bold",
//     color: "black",
//     fontFamily: '"Poppins", serif',
//     [theme.breakpoints.down("xs")]: {
//       fontSize: 16, // Smaller font for mobile devices
//       fontWeight: "bold",
//       color: "black",
//     },
//   },
// }));

// const LoadingSpinner = ({ open }) => {
//   const classes = useStyles();

//   return (
//     <Backdrop className={classes.backdrop} open={open}>
//       <div className={classes.card}>
//         <img
//           className={classes.spinner}
//           alt="Loading..."
//           src={require("../../assets/gif/ClockLoader.gif")}
//         />
//         <Typography fontWeight={"bold"} className={classes.text}>
//           Loading...Please wait
//         </Typography>
//       </div>
//     </Backdrop>
//   );
// };

// export default LoadingSpinner;

// ****** New Code To Show Lottie JSON Files ******
import React from "react";
import { makeStyles } from "@mui/styles";
import { Backdrop, Typography } from "@mui/material";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/lottie/Loading.json"; // your .json file

const useStyles = makeStyles((theme) => ({
  backdrop: {
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    position: "fixed",
    alignItems: "center",
    justifyContent: "center",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  card: {
    width: "50%",
    maxWidth: "400px",
    height: "auto",
    display: "flex",
    textAlign: "center",
    borderRadius: "8px",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  spinner: {
    width: "90%",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "50%",
    },
  },
  text: {
    fontSize: 18,
    fontWeight: "bold",
    color: "black",
    fontFamily: '"Poppins", serif',
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      fontWeight: "bold",
      color: "black",
    },
  },
}));

const LoadingSpinner = ({ open }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div className={classes.card}>
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          className={classes.spinner}
        />
        <Typography fontWeight={"bold"} className={classes.text}>
          Loading... Please wait
        </Typography>
      </div>
    </Backdrop>
  );
};

export default LoadingSpinner;
